// 'use client'
// import { GoogleAddressAutocomplete } from "@/components/GoogleAddressAutocomplete";
import { GoogleAddressAutocomplete } from "./Common/GoogleAddressAutocomplete";
// import { useAddressBarEvent } from "@/ui/hooks/useAddressBarEvent";
import { useAddressBarEvent } from "../hooks/useAddressBarEvent";
// import { AddressFormValues } from "@/ui/types/checkAvailability";
import { AddressFormValues } from "../ModalClass/types";
// import { GoogleAutoCompleteResult } from "@/ui/types/google";
import { GoogleAutoCompleteResult } from "../ModalClass/types";
import { useEffect, useRef, useState } from "react";
import { FormikProps } from "formik";
// import { Input } from "@/components/Input";
import { Input } from "./Common/Input";
// import { SessionService } from "../api/addressCheckService";
// import { addressCheckService } from "@/api/addressCheckService";
// import Icon from "../../../packages/ui/src/components/Icon/icon";
// import { tree } from "next/dist/build/templates/app-page";
// import WinLoader from "@/components/winLoader/page";
import Icon from "./Common/Icon/icon";
import { addressCheckService } from "../api/addressCheckService";
import { SessionService } from "../api/sessionService";
import WinLoader from "./Common/winLoader/page";

export default function AddressSearch() {
  let buyUri: string | undefined;
  buyUri=process.env.REACT_APP_BUYURI;
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const updateWidth = () => {
    const width = window.innerWidth;
    setIsMobile(width <= 1023);
  };
  
  useEffect(() => {
    updateWidth(); 
    window.addEventListener('resize', updateWidth); 
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const [staticMapAddress, setStaticMapAddress] = useState<string>();
  const [isAddressAvailable, setIsAddressAvailable] = useState<boolean>(true);
  const [addressUnit, setAddressUnit] = useState<string>('');
  const [buyToken, setBuyToken] = useState('');
  const [addressData, setAddressData] = useState<string>('');
  const [isAddressSearch, setisAddressSearch] = useState(false);
  const [isProductAvailability, setisProductAvailability] = useState(false);
  const [dfAddressId, setdfAddressId] = useState('');
  const formRef = useRef<FormikProps<AddressFormValues>>(null);
  const [techType, setTechType] = useState('');
  const [gpid, setGpid] = useState<any>('');
  const [processSteps, setPocessSteps] = useState<string>('addressSearch');
  const [formattedAddress, setFormattedAddress] = useState({
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    postalCode: ''
  });
  const {
    setEnteredAddress,
    setSelectedSuggestion,
    setAreSuggestionsProvided,
    trackAddressBarEvent,
  } = useAddressBarEvent();
  const onClickAutocomplete = async (
    addressResult?: GoogleAutoCompleteResult,
  ) => {
    if (!addressResult) return;
    setStaticMapAddress(addressResult.address);
    setSelectedSuggestion(addressResult.address);
    setGpid(addressResult.placeId);
    const fieldUnit = addressResult.unit || formRef.current?.values;

    setGpid(addressResult.placeId);
    formRef.current?.setFieldValue("address", addressResult.address);
    formRef.current?.setFieldValue("unit", fieldUnit);
    const formattedAddress = formatAddress(addressResult.address);
    if (formattedAddress) {
      setFormattedAddress(formattedAddress);
    }
    console.log("formattedAddress", formattedAddress);
    setAddressData(addressResult.address);
  };
  const onChangeAddress = async ({ address = "", unit = "" }) => {
    setStaticMapAddress(address);
    setEnteredAddress(address);
    if (address) {
      setIsAddressAvailable(false);
    } else {
      setIsAddressAvailable(true);
    }
    const validAddress = address;
    const validUnit = unit;

    formRef.current?.setFieldValue("address", validAddress);
    formRef.current?.setFieldValue("unit", validUnit);
    setAddressData(validAddress);
  };
  const handleAddressUnitChange = async ({ unit = '' }) => {
    setAddressUnit(unit);
  };
  function editAddress() {
    setPocessSteps('addressSearch');
    formRef.current?.resetForm();
    if(!staticMapAddress) 
      {
      setIsAddressAvailable(true);
    }
    else{
      setIsAddressAvailable(false);
    }
    setisAddressSearch(false);
  }

  useEffect(() => {
    const objService = new SessionService();

    const fetchData = async () => {
      try {
        const response = await objService.getSession();
        if (response) {
          setBuyToken(response?.token);
        } else {
          console.log('No response data');
        }
      } catch (error) {
        console.log('Error data');
        console.error(error);
      }
    };
    fetchData();
  }, []);


  useEffect(() => {

    const fetchAddressData = async () => {
      try {
        setIsLoading(true);
        const objService = new addressCheckService();
        const response = await objService.getAddressSearch(buyToken, formattedAddress
        );
        if (response) {
          if (response?.data?.dfAddressId) {
            setdfAddressId(response?.data?.dfAddressId);
            setTechType(response?.data?.techType);
            setPocessSteps('serviceAvailable');
            setIsLoading(false);
          }
          else {
            setPocessSteps('serviceUnavailable');
            setIsLoading(false);
          }
          console.log(response?.techType);
          console.log(response.dfAddressId);
          console.log(response, "token");
          // console.log(response,"home page");
        } else {
          console.log('No response data');
        }
      } catch (error) {
        console.log('Error data');
        console.error(error);
        setIsLoading(false);
      }
      setisAddressSearch(false);
    };
    if (isAddressSearch) {
      fetchAddressData();
    }
  }, [buyToken, formattedAddress, isAddressSearch]);

  function handleCALClick() {
    setisAddressSearch(true);
  }
  function nofifyMeClick(){
    window.location.href="https://www.windstream.com/fiber-form";
    //window.open('https://www.windstream.com/fiber-form','_blank');
  }
  function GetPricing(){
    const queryParams='?gpid='+gpid+'&dfaddressid='+dfAddressId+'&appName=standaloneapp';
     // window.open('https://dev-smb.windstream.com/buy?'+queryParams,'_blank');
    // window.open('https://dev.kineticbusiness.com/buy?'+queryParams,'_blank');
     window.open(buyUri+queryParams,'_blank');
     
      //window.open('http://localhost:3333/?'+queryParams,'_blank');
  }
  function formatAddress(address: string) {
    const addressRegex = /^(.+?),\s*(.*?),\s*([A-Z]{2})\s*(\d{5}[A-Z]?)$/;
    const match = address.match(addressRegex);

    if (match) {
      const [, addressLine1, city, state, postalCode] = match;
      return {
        addressLine1,
        addressLine2: "", // No address line 2 in this example
        city,
        state,
        postalCode
      };
    } else {
      // Handle the case where the address doesn't match the expected format
      console.error("Address format is incorrect");
      return null;
    }
  }
  return (
    <div className="twp">
       {isLoading &&(
        <div>
           <WinLoader zIndex="z-40" />
          </div>
      )
 
      }
      {processSteps == 'addressSearch' && (
        <div>
          <header className="mb-4 sm:mb-8">
            <div className="text-center">
              <span className="font-dinpro text-xl font-bold  text-left text-[#231f20]">
                Let’s See what’s available at your business address.
              </span>
            </div>
          </header>
          <form className="flex flex-col addressform md:pl-0 md:p-3 justify-center items-center w-full">
            <div className="w-full flex flex-col space-y-4 [ md:flex-row md:space-x-4 md:space-y-0 ] mb-4">
              <div className="relative w-full flex-shrink-0 [ md:w-[49%] ]">
                <GoogleAddressAutocomplete
                  name="address"
                  placeholder="Enter full address*"
                  onSelectAddress={addressResult => {
                    onClickAutocomplete(addressResult);
                  }}
                  onSuggestionsChange={suggestions => {
                    setAreSuggestionsProvided(suggestions.length > 0);
                  }}
                  onChange={address => {
                    onChangeAddress({ address, unit: '' });
                  }}
                  value={staticMapAddress}
                  containerClassName=""
                  fixedPositionedSuggestions
                />
              </div>
              <div className="relative [ md:w-[17%] ]">
                <label className="invisible absolute sr-only">Apt Number</label>
                <Input
                  className="input-sm"
                  name="Unit"
                  placeholder="Unit"
                  type="text"
                  value={addressUnit}
                  onChange={event => {
                    const addressUnitval = event.target.value;
                    handleAddressUnitChange({ unit: addressUnitval });
                  }}
                // onBlur={handleInputBlur}
                />
              </div>
              <button disabled={isAddressAvailable} className="w-full sm:w-[13.3rem] font-bold text-[#fff] switch-md bg-gradient-to-r from-[#0098b8] to-[#007c83]
                                               disabled:bg-[#cac9c8] disabled:from-[#cac9c8] disabled:to-[#cac9c8] disabled:text-[#fff]"
                type="button"
                id="AvailabilityBtnHeaderPL"
                onClick={handleCALClick}
              >Check Availability</button>
            </div>
          </form>
        </div>
      )}
      {processSteps == 'serviceAvailable' && (
        <div className='flex-row flex-wrap '>
          <div className='address-container flex flex-grow justify-center sm:px-8'>
            <Icon iconName='location_on' width={24} height={24} />
            <p className='font-montserrat text-3xs text-[#5a5a5a]'>{addressData}</p>
            <button type='button' className='text-[#0098b8] ml-[10px] underline' onClick={editAddress}>edit</button>
          </div>
          <div className='w-full flex flex-grow justify-center pt-3'>
            <div className="w-[649px] font-bold font-dinpro leading-none text-center text-cyan-600 text-[28px] sm:text-[28px]">
              {techType && techType.toUpperCase() == 'FIBER' && (
                <span>Great news, your business is ready for our best Fiber Internet plans</span>
              )}
              {techType && techType.toUpperCase() != 'FIBER' && (
                <span>Our fastest Business Broadband Internet is available for your business.</span>
              )}
            </div>

          </div>
          <div className='w-full flex flex-grow justify-center pt-3 pb-3'>
            <div className="w-[467px] text-center text-stone-800  font-montserrat text-3xs text-base leading-normal">
              {techType && techType.toUpperCase() == 'FIBER' && (
                <span>
                  Lightning-fast, worry-free internet with 99.9% reliability and up to 1 Gig upload and download speeds.
                </span>
              )}
              {techType && techType.toUpperCase() != 'FIBER' && (
                <span>
                  Kinetic Business Internet is a reliable, wired internet connection delivered by a fiber-backed network.
                </span>
              )}
            </div>
          </div>
          <div className='w-full flex flex-grow justify-center'>
            <button className="w-full sm:w-[252px] bg-gradient-to-r from-[#0098b8] to-[#007c83] h-[52px]" id="seeAvailablePlans" onClick={GetPricing}>
              <span className="text-white  font-bold font-dinpro text-[14px]  uppercase">Get Pricing<br /></span>
              <span className="text-white font-bold font-dinpro text-[9px]   uppercase">Buy Online Today</span>
            </button>
          </div>
          {!isMobile && (
            <div className='address-container flex flex-grow justify-center'>
              <span className="text-sm font-lato not-italic leading-[normal] tracking-[normal] text-left text-[#231f20] ml-[217px] mr-[216px] mt-[18px] mb-0">
                Have questions?
                <span className="text-base font-montserrat text-3xs">  </span>
                call us at
                <span className="text-style-4">  </span>
                <span className="font-montserrat text-3xs font-bold text-[#0098b8] underline"><a href="tel:+1-866-491-2462">1-866-491-2462</a></span>
                <span className="text-style-6">  </span>
              </span>
            </div>
          )}
          {isMobile && (
            <div className="text-center pt-4">
              <span className="text-stone-800 text-base font-medium font-montserrat">Have questions?</span>
              <span className="text-stone-800 text-base font-medium font-montserrat">call us at</span>
              <span className="text-stone-800 text-base font-normal font-montserrat"> </span>
              <span className="text-cyan-600 text-base font-bold font-montserrat underline"><a href="tel:+1-866-491-2462">1-866-491-2462</a></span>
              <span className="text-cyan-600 text-sm font-bold font-montserrat"> </span>
            </div>
          )}
        </div>
      )}
      {processSteps == 'serviceUnavailable' && (

        <div>
          {!isMobile && (
            <div className="pl-2">
              <div className="flex gap-[29px]">
                <Icon
                  iconName={"no-wifi"}
                  width={92}
                  height={92}
                ></Icon>
                <div className="w-[572px] flex flex-row flex-wrap gap-[16px]">
                  <p><strong>OOPS..!!! YOUR ADDRESS IS NOT YET SERVICEABLE</strong></p>
                </div>
              </div>
              <div className="button-section flex justify-center">
                <button className="w-[22rem] h-[42px] font-bold whitespace-nowrap" style={{ border: 'solid 2px #0098b8', color: '#0098b8' }} onClick={editAddress}>CHECK A DIFFERENT BUSINESS ADDRESS</button>
              </div>
            </div>
          )}
          {isMobile && (
            <div className="items-center justify-center p-2">
              <div className="flex items-center justify-center">
                <div className="w-16 h-16 relative">
                  <Icon
                    iconName={"no-wifi"}
                    width={92}
                    height={92}
                  />
                </div>
              </div>            
              <div className="w-80 pt-3 text-center text-stone-800 text-2xl font-bold font-dinpro leading-9">
                Oops...!! your address is not yet serviceable
              </div>
              
              <div className="w-80 h-10 pt-3  px-10 py-1.5 border-2 border-cyan-600 justify-center items-center gap-2.5 inline-flex">
                <div className="text-cyan-600 text-lg font-bold font-dinpro uppercase leading-loose whitespace-nowrap">
                  <button onClick={editAddress}>CHECK A DIFFERENT BUSINESS ADDRESS</button>
                </div>
              </div>
            </div>

          )}
        </div>
      )}
    </div>
  );
}
